export namespace DashboardFilterListHelper {
  export const partnerPortalQueryParamKey = 'utm_source';
  export const partnerPortalQueryParamValue = 'partnerportal_widget';

  export enum PartnerPortalQueryParam {
    working = 'working',
    error = 'error',
    maintenance = 'maintenance',
    offline = 'offline',
  }
}
